export default class Locale_OverviewActiveToggler {
	ShowOnlyActive: string = "Show active";
	ShowActiveAndInactive: string = "Show active and inactive";
	ShowOnlyInactive: string = "Show inactive";
	ShowingActive: string = "Showing active";
	ShowingInactive: string = "Showing inactive";
	ShowingActiveAndInactive: string = "Showing active and inactive";
}